module.exports = __webpack_public_path__ + "static/img/ic_fail.85a3bba7.png";